export default {"src":"/seller-forums/v2/_next/static/media/pin.241d482a.svg","height":20,"width":20};